import React, {Component} from 'react'
import {connect} from 'react-redux'
import propTypes from 'prop-types'
import {prefix} from 'helpers/component'
import themeVars from 'theme/themeVars'
import defaultSettings from '../../config/defaultSettings'
import TextField from '../../components/textField'
import {DateEditor} from '../../components/inlineEditor'
import {formatLocaleDate} from 'helpers/dates'
import {getRegionalDateFormat, getRegionalLocale} from 'selectors/settings'
import './datePicker.scss'

const getClass = prefix('datePicker-')

class _DatePicker extends Component {
  state = {
    open: false,
    anchor: null,
    focussed: false,
  }

  open = (e) => {
    this.setState({
      open: true,
      anchor: e.currentTarget,
      focussed: true,
    })
  }

  focus = () => this.textField.focus()

  close = () => {
    this.setState({open: false})
    this.focusInput.focus()
    if (this.props.onClose) this.props.onClose()
  }

  change = (v) => {
    this.props.onChange(null, v ? new Date(v) : null)
    this.close()
  }

  keyDown = (e) => {
    if ([13, 32, 37, 38, 39, 40].indexOf(e.keyCode) >= 0) {
      this.textField.focus()
      e.stopPropagation()
      e.preventDefault()
      return false
    }
  }

  focussed = () => {
    this.setState({focussed: true})
  }

  blurred = () => {
    this.setState({focussed: false})
  }

  render() {
    const {
      allowNone,
      dateFormat = defaultSettings.dateFormat,
      locale = defaultSettings.locale,
      value,
      ...otherProps
    } = this.props
    const {
      disabled,
      errorText,
      floatingLabelText,
      fullWidth,
      hintText,
      onChange,
      onClick,
      onClose,
      underlineShow,
    } = otherProps
    const {open, anchor, focussed} = this.state

    const formattedDate = value ? formatLocaleDate(value, locale, dateFormat) : ''

    // Feign 'active' style whilst open or 'focussed'
    let floatingLabelStyle, underlineStyle = {borderColor: themeVars.palette.borderColor}
    if (focussed) {
      floatingLabelStyle = {color: themeVars.palette.primary1Color}
      underlineStyle = {borderBottomWidth: 2, borderColor: themeVars.palette.primary1Color}
    }

    return (
        <div className={getClass('container')}>
          <TextField
              onFocus={this.open}
              disabled={disabled}
              errorText={errorText}
              fullWidth={fullWidth}
              hintText={hintText}
              floatingLabelText={floatingLabelText}
              onChange={onChange}
              onClick={onClick}
              onClose={onClose}
              underlineShow={underlineShow}
              value={formattedDate}
              ref={e => {
                this.textField = e
              }}
              readOnly
              floatingLabelStyle={floatingLabelStyle}
              underlineStyle={underlineStyle}
          />
          <input
              onFocus={this.focussed}
              onBlur={this.blurred}
              onKeyDown={this.keyDown}
              readOnly
              ref={e => {
                this.focusInput = e
              }}
              className={getClass('focusInput')}
          />
          <DateEditor
              open={open}
              anchor={anchor}
              value={value}
              onCommit={this.change}
              onCancel={this.close}
              allowNone={allowNone}
              marginTop={-25}
          />
        </div>
    )
  }
}

_DatePicker.propTypes = {
  value: propTypes.oneOfType([
    propTypes.instanceOf(Date),
    propTypes.number,
  ]),
  onChange: propTypes.func.isRequired,  // (event: null, value: date)
  allowNone: propTypes.bool,
  locale: propTypes.string,
  dateFormat: propTypes.string,
  onClose: propTypes.func,
}

_DatePicker.defaultProps = {
  allowNone: false,
}

const mapStateToProps = (state) => ({
  locale: getRegionalLocale(state),
  dateFormat: getRegionalDateFormat(state),
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(_DatePicker)
